import React, { useEffect, useState } from "react";
import { Col, Container, Form, Row, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { BsArrowClockwise } from "react-icons/bs";
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";
import { BsExclamationCircleFill } from 'react-icons/bs';
import { loadModules } from 'esri-loader';

const AIRPORTS_LIVE_PM_KPI = ({ data, changeValues, filter, showModalCalRange }) => {

    const { setValues, values, calculoDias, calculoYesNo, calculoPerType, calculoPerTypeStatus, calculoFundingSources } = useKPIs();

    const [formValues, setFormValues] = useState({});
    const [attributes, setAttributes] = useState({});
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)



    useEffect(() => {
        getRegionalPartnerGeo();
    }, [filter.objectid]);

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {
        const datas = {
            project_type: {
                infrastructure: calculoPerType('type_foreseen_interven', 'infrastructure', filter.yearInit),
                reconstruction: calculoPerType('type_foreseen_interven', 'reconstruction', filter.yearInit),
                maintenances: calculoPerType('type_foreseen_interven', 'maintenances', filter.yearInit),
                horizontal: calculoPerType('type_foreseen_interven', 'horizontal', filter.yearInit)
            },
            TEN_TIndicators: {
                road_conn: calculoYesNo('rail_conn', filter.yearInit),
                clean_fuels: calculoYesNo('clean_fuels_avail', filter.yearInit),
                terminal_avail: calculoYesNo('terminal_avail', filter.yearInit)
            },
            TEN_TCompliance: {
                rail_conn: {
                    bef_rail_conn: calculoYesNo('bef_rail_conn', filter.yearInit),
                    aft_rail_conn: calculoYesNo('aft_rail_conn', filter.yearInit)
                },
                clean_fuels: {
                    bef_clean_fuels: calculoYesNo('bef_clean_fuels', filter.yearInit),
                    aft_clean_fuels: calculoYesNo('aft_clean_fuels', filter.yearInit)
                },
                terminal_avail: {
                    bef_terminal_avail: calculoYesNo('bef_terminal_avail', filter.yearInit),
                    aft_terminal_avail: calculoYesNo('aft_terminal_avail', filter.yearInit)
                }
            },
            project_status: {
                status_high_level: {
                    implemented: calculoPerTypeStatus('implemented', filter.yearInit),
                    ongoing_proj_fs: calculoPerTypeStatus('ongoing_proj_fs', filter.yearInit),
                    mature_proj_fs: calculoPerTypeStatus('mature_proj_fs', filter.yearInit),
                    proj_under_prep: calculoPerTypeStatus('proj_under_prep', filter.yearInit)
                },
                status_detailed: {
                    implemented: calculoPerTypeStatus('implemented', filter.yearInit),
                    ongoing_proj_fs: {
                        workCur: calculoPerType('ongoing_proj_fs', 'workCur', filter.yearInit),
                        tenderWork: calculoPerType('ongoing_proj_fs', 'tenderWork', filter.yearInit),
                        designTender: calculoPerType('ongoing_proj_fs', 'designTender', filter.yearInit),
                        tenderOngoing: calculoPerType('ongoing_proj_fs', 'tenderOngoing', filter.yearInit)
                    },
                    mature_proj_fs: {
                        finOngoing: calculoPerType('mature_proj_fs', 'finOngoing', filter.yearInit),
                        finProceduresNotyetStarted: calculoPerType('mature_proj_fs', 'finProceduresNotyetStarted', filter.yearInit),
                        finSourceNotInd: calculoPerType('mature_proj_fs', 'finSourceNotInd', filter.yearInit)
                    },
                    proj_under_prep: {
                        feasOnGoing: calculoPerType('proj_under_prep', 'feasOnGoing', filter.yearInit),
                        feasUnderTen: calculoPerType('proj_under_prep', 'feasUnderTen', filter.yearInit),
                        financing: calculoPerType('proj_under_prep', 'financing', filter.yearInit)
                    }
                }
            },
            project_funding: {
                funding_source: {
                    proj_fund_nat_budg: calculoFundingSources('proj_fund_nat_budg', filter.yearInit),
                    proj_fund_wb: calculoFundingSources('proj_fund_wb', filter.yearInit),
                    proj_fund_ebrd: calculoFundingSources('proj_fund_ebrd', filter.yearInit),
                    proj_fund_eib: calculoFundingSources('proj_fund_eib', filter.yearInit),
                    other_ifi: calculoFundingSources('other_ifi', filter.yearInit),
                    concessions: calculoFundingSources('concessions', filter.yearInit),
                    eu_fund: calculoFundingSources('eu_fund', filter.yearInit),
                    other_fund: calculoFundingSources('other_fund', filter.yearInit)
                },
                allocated_funding: {
                    proj_fund_nat_budg: calculoYesNo('proj_fund_nat_budg', filter.yearInit),
                    proj_fund_wb: calculoYesNo('proj_fund_wb', filter.yearInit),
                    proj_fund_ebrd: calculoYesNo('proj_fund_ebrd', filter.yearInit),
                    proj_fund_eib: calculoYesNo('proj_fund_eib', filter.yearInit),
                    other_ifi: calculoYesNo('other_ifi', filter.yearInit),
                    concessions: calculoYesNo('concessions', filter.yearInit),
                    eu_fund: calculoYesNo('eu_fund', filter.yearInit),
                    other_fund: calculoYesNo('other_fund', filter.yearInit)
                }
            },
            project_timeline: {
                tender_start_date: calculoDias('tender_start_date_curr_est', 'tender_start_date_init_fore', null, filter.yearInit),
                design_comp_date: calculoDias('design_comp_date_curr_est', 'design_comp_date_fore', null, filter.yearInit),
                proj_comp_date: calculoDias('proj_comp_date_curr_est', 'proj_comp_date_fore', null, filter.yearInit)
            },
            project_tech_status: {
                pre_feasi_study: calculoYesNo('pre_feasi_study', filter.yearInit),
                feasi_study: calculoYesNo('feasi_study', filter.yearInit),
                concept_design: calculoYesNo('concept_design', filter.yearInit),
                prelim_design: calculoYesNo('prelim_design', filter.yearInit),
                detail_design: calculoYesNo('detail_design', filter.yearInit),
                environ_impact_assess: calculoYesNo('environ_impact_assess', filter.yearInit)
            },
            social_indicators: {
                si_ann_traff_dem_gro: "",
                si_modal_trans: "",
                si_ann_traff_acci_rate_red: ""
            },
            eco_indicators: {
                ei_eirr: "",
                ei_npv: "",
                ei_sdr: "",
                ei_proj_plan_des_cost: "",
                ei_proj_const_cost: "",
                ei_total_proj_cost: ""
            },
            financial_indicators: {
                fi_firr: "",
                fi_fnpv: "",
                fi_fdr: "",
                fi_wacc: "",
                fi_firts_year_prof: "",
                fi_dscr: ""
            },
            environmental_indicators: {
                eni_co2_ems: "",
                eni_nox_ems: "",
                eni_so2_ems: "",
                eni_nmhc_ems: "",
                eni_ppm: "",
                eni_noise_level: "",
                eni_cli_change_res: "",
                eni_prote_natua_aff: ""
            }
        }

        changeValues(datas)
    }
    const getRegionalPartnerGeo = async () => {
        console.log("getRegionalPartnerGeo is called");
        try {
            const [Query, query] = await loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/10";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `live_airports_proj_id=${filter.objectid}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            console.log("Executing query");
            const results = await query.executeQueryJSON(queryUrl, queryObject);
            console.log("Query executed", results);

            if (results.features.length > 0) {
                const attributes = results.features[0].attributes;
                setAttributes(attributes);
                setFormValues(attributes);
                setStatusTabDisabled(false);

            } else {
                console.log("No features found with the given npmRoadId");
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const key = name.split('.').pop();

        // Detecta el tipo original del valor
        const originalValue = formValues[key];
        let newValue = value;

        // Convertir a número si el valor original es un número
        if (!isNaN(originalValue) && originalValue !== null && originalValue !== "") {
            newValue = Number(value);
        }

        setFormValues({
            ...formValues,
            [key]: newValue,
        });
    };


    const generateFormFields = (formValues, typeForm) => {
        const excludedFields = ["objectid", "globalid", "npm_road_id"];

        return Object.keys(formValues)
            .filter(key => !excludedFields.includes(key))
            .map(key => (
                <Col lg={6} key={key}>
                    <TODIS_FORM_FIELD
                        id={`${typeForm}.${key}`}
                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                        name={`${typeForm}.${key}`}
                        disabled={true}
                        holder={formValues[key]}
                        onChange={handleChange}
                    />
                </Col>
            ));
    };


    return (
        <Tabs defaultActiveKey="project_type" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="project_type" title="Project Type" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.infrastructure" label="New infrastructure (%)" name="project_type.infrastructure" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.reconstruction" label="Reconstruction/rehabilitation (%)" name="project_type.reconstruction" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.maintenances" label="Maintenance (%)" name="project_type.maintenances" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_type.horizontal" label="Maintenance (%)" name="project_type.horizontal" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="TEN_TIndicators" title="Targeted TEN-T indicators" className={style.tabHeight} style={{ height: "66vh" }}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Percentage of projects per type of targeted TEN-T indicator</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="TEN_TIndicators.road_conn" label="Rail Connection (%)" name="TEN_TIndicators.road_conn" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="TEN_TIndicators.clean_fuels_avail" label="Clean fuels availability (%)" name="TEN_TIndicators.clean_fuels_avail" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="TEN_TIndicators.terminal_avail" label="Terminal availability (%)" name="TEN_TIndicators.terminal_avail" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="TEN_TCompliance" title="TEN-T Compliance" className={style.tabHeight} style={{ height: "71vh" }}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.rail_conn.bef_rail_conn" label="Rail connection compliance before the implementation of project(s) (%)" name="TEN_TCompliance.rail_conn.bef_rail_conn" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.rail_conn.aft_rail_conn" label="Rail connection compliance after the implementation of project(s) (%)" name="TEN_TCompliance.rail_conn.aft_rail_conn" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.clean_fuels.bef_clean_fuels" label="Clean fuels availability before the implementation of project(s) (%)" name="TEN_TCompliance.clean_fuels.bef_clean_fuels" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.clean_fuels.aft_clean_fuels" label="Clean fuels availability after the implementation of project(s) (%)" name="TEN_TCompliance.clean_fuels.aft_clean_fuels" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.terminal_avail.bef_terminal_avail" label="Terminal availability before the implementation of project(s) (%)" name="TEN_TCompliance.terminal_avail.bef_terminal_avail" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="TEN_TCompliance.terminal_avail.aft_terminal_avail" label="Terminal availability after the implementation of project(s) (%)" name="TEN_TCompliance.terminal_avail.aft_terminal_avail" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_status" title="Project Status" className={style.tabHeight} style={{ height: "62vh" }}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Implementation status (general)</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.implemented" label="Implemented projects (%)" name="project_status.status_high_level.implemented" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.ongoing_proj_fs" label="Ongoing projects – funding secured (%)" name="project_status.status_high_level.ongoing_proj_fs" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.mature_proj_fs" label="Mature projects (%)" name="project_status.status_high_level.mature_proj_fs" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_high_level.proj_under_prep" label="Projects under preparation (%)" name="project_status.status_high_level.proj_under_prep" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Implementation status (detailed)</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_status.status_detailed.implemented" label="Implemented projects (%)" name="project_status.status_detailed.implemented" disabled={true} />
                                </Col>
                                <Col lg={12}>
                                    <div style={{ borderBottom: "3px solid #004494" }}>
                                        <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>On-going projects</Form.Label>
                                    </div>
                                    <Row style={{ paddingTop: "15px" }}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.workCur" label="Works currently under execution (%)" name="project_status.status_detailed.ongoing_proj_fs.workCur" disabled={true} />
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.tenderWork" label="Tender for works/design-build ongoing (%)" name="project_status.status_detailed.ongoing_proj_fs.tenderWork" disabled={true} />
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.designTender" label="Design/Tender Dossier for DB under preparation (%)" name="project_status.status_detailed.ongoing_proj_fs.designTender" disabled={true} />
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.ongoing_proj_fs.tenderOngoing" label="Tender for design on-going or about to start (%)" name="project_status.status_detailed.ongoing_proj_fs.tenderOngoing" disabled={true} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12}>
                                    <div style={{ borderBottom: "3px solid #004494" }}>
                                        <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Mature project (feasibility study ready, funding not secured yet)</Form.Label>
                                    </div>
                                    <Row style={{ paddingTop: "15px" }}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finOngoing" label="Funding source identified (principle agreement reached), procedures on-going (%)" name="project_status.status_detailed.mature_proj_fs.finOngoing" disabled={true} />
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finProceduresNotyetStarted" label="Funding source identified (principle agreement reached), procedures not yet started (%)" name="project_status.status_detailed.mature_proj_fs.finProceduresNotyetStarted" disabled={true} />
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.mature_proj_fs.finSourceNotInd" label="Funding source not identified" name="project_status.status_detailed.mature_proj_fs.finSourceNotInd" disabled={true} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg={12}>
                                    <div style={{ borderBottom: "3px solid #004494" }}>
                                        <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Projects under preparation</Form.Label>
                                    </div>
                                    <Row style={{ paddingTop: "15px" }}>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.feasOnGoing" label="Feasibility study on-going (%)" name="project_status.status_detailed.proj_under_prep.feasOnGoing" disabled={true} />
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.feasUnderTen" label="Feasibility study under tendering (%)" name="project_status.status_detailed.proj_under_prep.feasUnderTen" disabled={true} />
                                        </Col>
                                        <Col lg={6}>
                                            <TODIS_FORM_FIELD id="project_status.status_detailed.proj_under_prep.financing" label="Funding for Feasibility Study secured, procurement not yet started (%)" name="project_status.status_detailed.proj_under_prep.financing" disabled={true} />
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_funding" title="Project Funding" className={style.tabHeight} style={{ height: "62vh" }}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Funding Sources</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_nat_budg" label="National Budget (%)" name="project_funding.funding_source.proj_fund_nat_budg" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_wb" label="World Bank (%)" name="project_funding.funding_source.proj_fund_wb" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_ebrd" label="European Bank for Reconstruction and Development (%)" name="project_funding.funding_source.proj_fund_ebrd" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.proj_fund_eib" label="European Investment Bank (%)" name="project_funding.funding_source.proj_fund_eib" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.other_ifi" label="Other International Financial Institutions (%)" name="project_funding.funding_source.other_ifi" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.concessions" label="Concessions (%)" name="project_funding.funding_source.concessions" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.eu_fund" label="EU Funds (%)" name="project_funding.funding_source.eu_fund" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.funding_source.other_fund" label="Other funding source (%)" name="project_funding.funding_source.other_fund" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Allocated Funding</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.proj_fund_nat_budg" label="National Budget (%)" name="project_funding.allocated_funding.proj_fund_nat_budg" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.proj_fund_wb" label="World Bank (%)" name="project_funding.allocated_funding.proj_fund_wb" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.proj_fund_ebrd" label="European Bank for Reconstruction and Development (%)" name="project_funding.allocated_funding.proj_fund_ebrd" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.proj_fund_eib" label="European Investment Bank (%)" name="project_funding.allocated_funding.proj_fund_eib" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.other_ifi" label="Other International Financial Institutions (%)" name="project_funding.allocated_funding.other_ifi" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.concessions" label="Concessions (%)" name="project_funding.allocated_funding.concessions" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.eu_fund" label="EU Funds (%)" name="project_funding.allocated_funding.eu_fund" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="project_funding.allocated_funding.other_fund" label="Other funding source (%)" name="project_funding.allocated_funding.other_fund" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_timeline" title="Project Timeline" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_timeline.tender_start_date" label="Tender start date deviation (no. of months)" name="project_timeline.tender_start_date" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_timeline.design_comp_date" label="Design completion date deviation (no. of months)" name="project_timeline.design_comp_date" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_timeline.proj_comp_date" label="Project completion date deviation (no. of months)" name="project_timeline.proj_comp_date" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="project_tech_status" title="Project Technical Status" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.pre_feasi_study" label="Percentage of projects with Pre-feasibility Study (%)" name="project_tech_status.pre_feasi_study" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.feasi_study" label="Percentage of projects with Feasibility Study" name="project_tech_status.feasi_study" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.concept_design" label="Percentage of projects with Concept Design" name="project_tech_status.concept_design" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.prelim_design" label="Percentage of projects with Preliminary Design" name="project_tech_status.prelim_design" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.detail_design" label="Percentage of projects with Detailed Design" name="project_tech_status.detail_design" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="project_tech_status.environ_impact_assess" label="Percentage of projects with Environmental Impact Assessment" name="project_tech_status.environ_impact_assess" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="social_indicators" title="Social Indicators" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="social_indicators.si_ann_traff_dem_gro" label="Annual Traffic Demand Growth (% of projects within user-defined ranges)" name="social_indicators.si_ann_traff_dem_gro" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("social_indicators.si_ann_traff_dem_gro", "si_ann_traff_dem_gro")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="social_indicators.si_modal_trans" label="Modal transfer - if applicable (% of projects within user-defined ranges)" name="social_indicators.si_modal_trans" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("social_indicators.si_modal_trans", "si_modal_trans")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="social_indicators.si_ann_traff_acci_rate_red" label="Annual Accident Rate Reduction (% of projects within user-defined ranges)" name="social_indicators.si_ann_traff_acci_rate_red" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("social_indicators.si_ann_traff_acci_rate_red", "si_ann_traff_acci_rate_red")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="eco_indicators" title="Economic Indicators" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_eirr" label="Economic Internal Rate of Return (% of projects within user-defined ranges)" name="eco_indicators.ei_eirr" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("eco_indicators.ei_eirr", "ei_eirr")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_npv" label="Net Present Value (% of projects within user-defined ranges)" name="eco_indicators.ei_npv" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("eco_indicators.ei_npv", "ei_npv")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_sdr" label="Social Discount Rate (% of projects within user-defined ranges)" name="eco_indicators.ei_sdr" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("eco_indicators.ei_sdr", "ei_sdr")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_proj_plan_des_cost" label="Project Planning & Design Cost (% of projects within user-defined ranges)" name="eco_indicators.ei_proj_plan_des_cost" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("eco_indicators.ei_proj_plan_des_cost", "ei_proj_plan_des_cost")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_proj_const_cost" label="Project Construction Cost (% of projects within user-defined ranges)" name="eco_indicators.ei_proj_const_cost" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("eco_indicators.ei_proj_const_cost", "ei_proj_const_cost")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="eco_indicators.ei_total_proj_cost" label="Total Project Cost (% of projects within user-defined ranges)" name="eco_indicators.ei_total_proj_cost" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("eco_indicators.ei_total_proj_cost", "ei_total_proj_cost")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="financial_indicators" title="Financial Indicators" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_firr" label="Financial Internal Rate of Return (% of projects within user-defined ranges)" name="financial_indicators.fi_firr" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("financial_indicators.fi_firr", "fi_firr")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_fnpv" label="Financial Net Present Value (% of projects within user-defined ranges)" name="financial_indicators.fi_fnpv" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("financial_indicators.fi_fnpv", "fi_fnpv")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_fdr" label="Financial Discount Rate (% of projects within user-defined ranges)" name="financial_indicators.fi_fdr" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("financial_indicators.fi_fdr", "fi_fdr")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_wacc" label="Weighted Average Cost of Capital (% of projects within user-defined ranges)" name="financial_indicators.fi_wacc" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("financial_indicators.fi_wacc", "fi_wacc")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_firts_year_prof" label="First year of profit (% of projects within user-defined ranges)" name="financial_indicators.fi_firts_year_prof" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("financial_indicators.fi_firts_year_prof", "fi_firts_year_prof")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="financial_indicators.fi_dscr" label=": Debt Service Coverage Ratio (% of projects within user-defined ranges)" name="financial_indicators.fi_dscr" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("financial_indicators.fi_dscr", "fi_dscr")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="environmental_indicators" title="Environmental Indicators" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_co2_ems" label="CO2 emissions (% of projects within user-defined ranges)" name="environmental_indicators.eni_co2_ems" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("environmental_indicators.eni_co2_ems")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_nox_ems" label="NOx emissions (% of projects within user-defined ranges)" name="environmental_indicators.eni_nox_ems" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("environmental_indicators.eni_nox_ems", "eni_nox_ems")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_so2_ems" label="SO2 emission (% of projects within user-defined ranges)" name="environmental_indicators.eni_so2_ems" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("environmental_indicators.eni_so2_ems", "eni_so2_ems")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_nmhc_ems" label="Non-methane hydrocarbons (% of projects within user-defined ranges)" name="environmental_indicators.eni_nmhc_ems" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("environmental_indicators.eni_nmhc_ems", "eni_nmhc_ems")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_ppm" label="Particulate matter (ppm) (% of projects within user-defined ranges)" name="environmental_indicators.eni_ppm" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("environmental_indicators.eni_ppm", "eni_ppm")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_noise_level" label="Noise levels along the section (% of projects within user-defined ranges)" name="environmental_indicators.eni_noise_level" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("environmental_indicators.eni_noise_level", "eni_noise_level")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_cli_change_res" label="Climate Change Resilience (% of projects with effect on climate resilience)" name="environmental_indicators.eni_cli_change_res" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("environmental_indicators.eni_cli_change_res", "eni_cli_change_res")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                        <Col lg={5}>
                            <TODIS_FORM_FIELD id="environmental_indicators.eni_prote_natua_aff" label="Protected natural areas affected (% of projects within user-defined ranges)" name="environmental_indicators.eni_prote_natua_aff" disabled={true} />
                        </Col>
                        <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                            <div onClick={() => showModalCalRange("environmental_indicators.eni_prote_natua_aff", "eni_prote_natua_aff")}>
                                <button
                                    className="define-period-button"
                                    style={{
                                        fontSize: '10px', // Tamaño de fuente más pequeño
                                        padding: '0.25rem 0.5rem', // Padding reducido
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        backgroundColor: '#e0e7ff',
                                        border: '2px solid #000080',
                                        borderRadius: '10px', // Bordes redondeados más pequeños
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                        color: '#000080',
                                        cursor: 'pointer',
                                        textAlign: 'center',
                                        transition: 'background-color 0.3s, transform 0.3s'
                                    }}
                                    onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                    onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                    onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                    onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <span>Define</span>
                                        <span>period</span>
                                        <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                    </div>
                                </button>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :

                <Tab eventKey="Others" title="Others" className={style.tabHeight}>
                    <Container>
                        <Row>
                            {generateFormFields(attributes)}
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default AIRPORTS_LIVE_PM_KPI;